/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NuovopayDeviceSyncStatusDto = {
    createdAt: string;
    status: NuovopayDeviceSyncStatusDto.status;
    finishedAt?: string;
};
export namespace NuovopayDeviceSyncStatusDto {
    export enum status {
        IN_PROGRESS = 'IN_PROGRESS',
        DONE = 'DONE',
        FAILED = 'FAILED',
        REPLACED = 'REPLACED',
    }
}

